var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.mostrarDetalles
    ? _c(
        "b-row",
        [
          _c(
            "b-col",
            { staticClass: "mt-3" },
            [
              _c(
                "b-card",
                {
                  attrs: {
                    title: _vm.$t("apeironGwApp.legajo.mensajes.tituloDetalle"),
                  },
                },
                [
                  _c(
                    "b-card-text",
                    [
                      _c(
                        "b-row",
                        [
                          _c("b-col", [
                            _c("h5", [_c("span", [_vm._v("Histórico:")])]),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass:
                                "area-responsive area-responsive-list",
                            },
                            [
                              _vm.itemsFiltrados.length > 0
                                ? _c(
                                    "b-list-group",
                                    [
                                      _c(
                                        "b-list-group-item",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.legajo.campos.campo"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", [
                                                    _vm._v("Valor anterior"),
                                                  ]),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", [
                                                    _vm._v("Nuevo valor"),
                                                  ]),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", [
                                                    _vm._v("Estado del campo"),
                                                  ]),
                                                ]),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.itemsFiltrados,
                                        function (item) {
                                          return _c(
                                            "b-list-group-item",
                                            { key: item.campo },
                                            [
                                              _c(
                                                "b-row",
                                                [
                                                  _c("b-col", [
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          !(
                                                            item.campo ?? ""
                                                          ).startsWith("alumno")
                                                            ? _vm.$t(
                                                                `apeironGwApp.legajo.fields.${item.campo}`
                                                              )
                                                            : _vm.$t(
                                                                "apeironGwApp.legajo.fields.alumnoRelacionado"
                                                              )
                                                        ),
                                                      },
                                                    }),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-col", [
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          item.valorAnterior
                                                        ),
                                                      },
                                                    }),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-col", [
                                                    _c("span", {
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          item.valorNuevo
                                                        ),
                                                      },
                                                    }),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("b-col", [
                                                    _c("span", {
                                                      class: {
                                                        "text-success":
                                                          "NUEVO" ==
                                                          item.estado,
                                                        "text-danger":
                                                          "ELIMINADO" ==
                                                          item.estado,
                                                        "text-warning":
                                                          "ACTUALIZADO" ==
                                                          item.estado,
                                                        "text-primary":
                                                          "SIN_CAMBIO" ==
                                                          item.estado,
                                                        "text-info":
                                                          "SIN_DATO" ==
                                                          item.estado,
                                                      },
                                                      domProps: {
                                                        textContent: _vm._s(
                                                          _vm.$t(
                                                            `apeironGwApp.legajo.estadosItem.${item.estado}`
                                                          )
                                                        ),
                                                      },
                                                    }),
                                                  ]),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.itemsFiltrados.length < 1
                                ? _c(
                                    "b-list-group",
                                    [
                                      _c(
                                        "b-list-group-item",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.legajo.mensajes.sinDatosDetalle"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.datos.length > 0
                    ? _c(
                        "b-card-text",
                        [
                          _c(
                            "b-row",
                            [
                              _c("b-col", [
                                _c("h5", [
                                  _c("span", [_vm._v("Datos adicionales:")]),
                                ]),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "area-responsive area-responsive-list",
                                },
                                [
                                  _c(
                                    "b-list-group",
                                    [
                                      _c(
                                        "b-list-group-item",
                                        [
                                          _c(
                                            "b-row",
                                            [
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.legajo.campos.campo"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c("b-col", [
                                                _c("strong", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          "apeironGwApp.legajo.campos.valor"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ]),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _vm._l(_vm.datos, function (pair) {
                                        return _c(
                                          "b-list-group-item",
                                          { key: pair.text },
                                          [
                                            _c(
                                              "b-row",
                                              [
                                                _c("b-col", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        _vm.$t(
                                                          `apeironGwApp.legajo.fields.${pair.text}`
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                                _vm._v(" "),
                                                _c("b-col", [
                                                  _c("span", {
                                                    domProps: {
                                                      textContent: _vm._s(
                                                        pair.value
                                                      ),
                                                    },
                                                  }),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }),
                                    ],
                                    2
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-card-text",
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: { variant: "outline" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.cerrarDetalles()
                                    },
                                  },
                                },
                                [
                                  _c("span", {
                                    domProps: {
                                      textContent: _vm._s(
                                        _vm.$t(
                                          "apeironGwApp.legajo.acciones.cerrar"
                                        )
                                      ),
                                    },
                                  }),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }